import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/main.vue'),
    meta: {
      isLogin: true,
      keep: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      isLogin: false,
      keep: false
    }
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import('../views/edit.vue'),
    meta: {
      isLogin: true,
      keep: false
    }
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/details.vue'),
    meta: {
      isLogin: true,
      keep: false
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  window.localStorage.setItem('previousRoute', from.path)
  let token = window.localStorage.getItem('token') || ''
  if (to.meta.isLogin) {
    if (token == '') {
      next('/login')
    } else {  
      next()
    }
  } else {
    next()
  }
})

export default router
